const ONCE_CAPTURE_EVENT_OPTIONS = { once: true, capture: true };
const PASSIVE_CAPTURE_EVENT_OPTIONS = { passive: true, capture: true };
const PASSIVE_EVENT_OPTIONS = { passive: true };
const CAPTURE_EVENT_OPTIONS = { capture: true };
export {
  CAPTURE_EVENT_OPTIONS,
  ONCE_CAPTURE_EVENT_OPTIONS,
  PASSIVE_CAPTURE_EVENT_OPTIONS,
  PASSIVE_EVENT_OPTIONS
};
//# sourceMappingURL=utils.js.map
